/* eslint-disable @typescript-eslint/ban-ts-comment */
import {AxiosResponse} from "axios";
import {CorePreferences, CorePreferencesRequest, CorePreferencesResult, Filter, FilterField} from "@mm-products/java-multima-framework";
import {taxGuruAxios} from "../../axios";
import { corePreferencesUrl } from "../../url";
import operator = FilterField.operator;

export const findPreferences = (keys: Array<string>, userId: string, toastId?: string): Promise<AxiosResponse<CorePreferencesResult>> => {
    const filter: Filter = {
        specificFilters: [{ name: "userId", value: userId }],
        or: keys.map((key) => ({ field: "prefKey", operator: operator.EQ, value: key })),
    };
    return taxGuruAxios.post(corePreferencesUrl.filter, filter, {
        // @ts-ignore
        toastId,
        // @ts-ignore
        noErrorToast: true,
    });
};

export const getPreference = (preferenceId: string, toastId?: string, signal?: AbortSignal, noErrorToast?: boolean): Promise<CorePreferences> => {
    return taxGuruAxios
        .get(corePreferencesUrl.get(encodeURIComponent(preferenceId)), {
            // @ts-ignore
            toastId,
            // @ts-ignore
            noErrorToast,
            signal,
        })
        .then((data) => data.data);
};

export const bulkSaveJsonPreferences = (keyValues: Array<[string, object]>, userId: string, toastId?: string): Promise<void> => {
    const request: Array<CorePreferencesRequest> = keyValues.map((entry) => ({
        prefKey: entry[0],
        userId,
        jsonValue: JSON.stringify(entry[1]),
    }));
    return taxGuruAxios.post(corePreferencesUrl.bulkSave, request, {
        // @ts-ignore
        toastId,
        // @ts-ignore
        noErrorToast: true,
    });
};

export const bulkSaveSimplePreferences = (keyValues: Array<[string, string]>, userId: string, toastId?: string): Promise<void> => {
    const request: Array<CorePreferencesRequest> = keyValues.map((entry) => ({
        prefKey: entry[0],
        userId,
        simpleValue: entry[1],
    }));
    return taxGuruAxios.post(corePreferencesUrl.bulkSave, request, {
        // @ts-ignore
        toastId,
        // @ts-ignore
        noErrorToast: true,
    });
};

export const listPreferences = (filter: Filter, signal?: AbortSignal, toastId?: string): Promise<AxiosResponse<CorePreferencesResult>> => {
    return taxGuruAxios.post(corePreferencesUrl.filter, filter, {
        signal,
        // @ts-ignore
        toastId,
    });
};

export const deletePreference = (preferenceId: string, toastId?: string): Promise<AxiosResponse<CorePreferences>> => {
    return taxGuruAxios.delete(corePreferencesUrl.delete(encodeURIComponent(preferenceId)), {
        // @ts-ignore
        toastId,
    });
};